<template>
  <section class="caseIndex">
    <!--搜索区-->
    <div class="search-wrap" :style='{background:"rgba(255,255,255,"+lightPesent+")"}'>
        <case-search-com @click.native="$router.push({name:'caseSearch'})"/>
    </div>
    <div class="mainTop" ref="mainTop">
      <div id="parallax">
        <div class="parallax" data-velocity="-.2" ref="parallax"></div>
      </div>
    </div>
    <!--导航-->
    <nav class="f28 grey9 t_center">
      <div :class="{'active':index===activeNavIndex}"
           @click="activeNavIndex = index"
           v-for="(item, index) in navData"
           :key="index">{{item.name}}</div>
    </nav>
    <section class="contentWrap">
      <!--精选-->
      <div v-if="activeNavIndex === 0">
        <section class="titleWrap">
          <h2 class="f40 bold">为你精选案例</h2>
          <h4 class="f28 grey6">甄选经典案例，查找匹配的修复方案</h4>
        </section>
        <ul class="caseList">
          <li v-for="(item, index) in flist" :key="index" @click="toCaseDetail(item.id,item.name)" :ref='index' :data-name='item.serviceName'>
            <img :src="formatImgUrl(item.showPic,400,300,true)" align="middle"/>
            <div>
              <div class="left">
                <h3 class="f32 oneClamp">{{item.serviceName}}</h3>
                <h4 class="f28 grey6 oneClamp">{{item.colorName}}{{item.material}}{{item.categoryName}}</h4>
              </div>
              <div class="right f40 bold">{{item.brandNameEn}}</div>
            </div>
          </li>
        </ul>
        <div ref='anli'></div>
      </div>
      <!--推荐-->
      <div v-else-if="activeNavIndex === 1">
        <van-list 
          v-model="sloading"
          :finished="sfinished"
          finished-text="没有更多了"
          @load="getRecommend">
          <ul class="recommendList">
            <li v-for="(item, index) in slist" :key="index">
              <case-item-com :item="item" @changeZan='changeZan' :types='10'></case-item-com>
            </li>
          </ul>
        </van-list>
      </div>
      <!--全部-->
      <div v-else-if="activeNavIndex === 2">
        <!--分类-->
        <div class="navBar">
          <ul class="classificationList f24 t_center bold">
            <li 
                v-for="(item, index) in classificationList" 
                :key="index" 
                @click="categoryTab(item.id)"
                :class="{'active':item.id===queryCategoryId}"
                >{{item.name}}</li>
          </ul>
          <div class="filterBtn f28 t_right" @click="$refs['filterPopup'].show()">
            <div>筛选</div>
          </div>
        </div>
        <van-list 
          v-model="tloading"
          :finished="tfinished"
          finished-text="没有更多了"
          @load="getExact">
          <ul class="allList">
            <li v-for="(item, index) in tlist" :key="index">
              <case-item-com :item="item" @changeZan='changeZan' :types='20'></case-item-com>
            </li>
          </ul>
        </van-list>
      </div>
    </section>
    <!--筛选弹窗-->
    <filter-popup ref="filterPopup"  @submitSearch='submitSearch'></filter-popup>
    
  </section>
</template>

<script>
  import caseApi from "@/axios/case";
  import parallax from 'vue-parallaxy';
  import publicObj from '@/assets/js/public'
  import filterPopup from './filterPopup';
  import zhugeObj from '@/assets/js/track'
  import $ from "jquery";
  import wxShare from "@/assets/js/wx.share"
  const img = 'https://img.yzcdn.cn/public_files/2017/09/05/3bd347e44233a868c99cf0fe560232be.jpg'
  export default {
    name: 'caseIndex',
    components: { filterPopup },
    data () {
      return {
        activeNavIndex: 0,
        navData: [
          { name: '精选' },
          { name: '推荐' },
          { name: '全部' }
        ],
        // 分类
        classificationList: [
          { 
            name: '包包',
            id : 3
          },
          { 
            name: '鞋靴',
             id : 4
          },
          { 
            name: '衣裤',
            id : 5
          },
          { 
            name: '配饰',
            id : 6
          }
        ],
        
        queryCategoryId : '',
        queryBrandIdId : '',
        querySymptomName : '',
        //3个分页控制，看着清除
        tpage : {
          current : 1,
          size : 5
        },
        tlist : [],
        tloading : false,
        tfinished : false,
        tcanMore : true,

        spage : {
          current : 1,
          size : 5
        },
        slist : [],
        sloading : false,
        sfinished : false,
        scanMore : true,

        fpage : {
          current : 1,
          size : 5
        },
        flist : [],
        floading : false,
        ffinished : false,
        fcanMore : true,
        lightPesent : 0
      }
    },
    watch : {
      activeNavIndex(val){
         zhugeObj.track({
          title: "案例曝光",
          content : {
            'tab':this.navData[val].name
          }
        });
      }
    },
    mounted(){
      zhugeObj.track({
        title : '案例首页-曝光'
      })
        publicObj.parallax();
        $('.parallax').scrolly({bgParallax: true});
        $('.mainTop .btn').scrolly({bgParallax: true});
        window.addEventListener("scroll", this.onScroll);
        setTimeout(()=>{
          let shareBody = {
            title : '包拯奢护案例锦集',
            desc : 'LV、香奈儿、古驰等大牌包包养护专家，提供专业奢品护理服务。',
            link : window.location.href
          }; 
          wxShare(shareBody);
        },1000)
    },
    computed:{

    },
    created(){
     
      this.getRecommend();
      this.getClassic();
      let searchObj = this.$route.query.searchObj;
      if(searchObj){
        let obj = JSON.parse(searchObj);
        this.activeNavIndex = 2;
        this.submitSearch(obj);
      }else{
         this.getExact();
      }
    },
    methods: {
      zhugeView(name){
    
        zhugeObj.track({
          title : '精选案例-曝光',
          content : {
            '案例名称' : name,
          }
        })
      },
      displayShow(){
        this.io = new IntersectionObserver((entrys) => {
          entrys.forEach((element) => {
            // console.log(element)
            if(element.isIntersecting){
              this.io.unobserve(element.target);
              //执行诸葛
              this.zhugeView(element.target.dataset.name)
            }
            // this.io.unobserve(element.target);
          })
        })
        setTimeout(()=>{
          this.flist.forEach((item,index)=>{
            this.io.observe(this.$refs[index][0]);
          })
          
        },1000)
    
        

      },
      onScroll(){
        // 头部480
        let height = $(document).scrollTop();
        this.lightPesent = $(document).scrollTop()/500;
      },
      changeZan(item){
        console.log(item)
        this.slist.forEach(element=>{
          if(element.id == item.id){
            if(element.zan){
              element.zanCount--;
            }else{
              element.zanCount++;
            }
            element.zan = !element.zan;
          }
        })
        this.tlist.forEach(element=>{
          if(element.id == item.id){
            if(element.zan){
              element.zanCount--;
            }else{
              element.zanCount++;
            }
            element.zan = !element.zan;
          }
        })
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      getClassic(){
        if(!this.fcanMore){
          return;
        }
        this.fcanMore = false;
        this.floading = true;
        
        let params = {
          current : this.fpage.current,
          size : this.fpage.size
        };

        caseApi.getClassic(params).then((res)=>{
          console.log(res)
          this.flist = this.flist.concat(...res.records || []);
          this.fcanMore = true;
          if(res.totalPage == this.fpage.current || res.totalPage == 0){
              this.ffinished = true;
          }
          if(res.records.length == 0){
            this.ffinished = true;
          }
          this.floading = false;
          this.fpage.current++;
          this.displayShow();
        })
      },
      getRecommend(){
        if(!this.scanMore){
          return;
        }
        this.scanMore = false;
        this.sloading = true;
        
        let params = {
          recommend : true,
          current : this.spage.current,
          size : this.spage.size
        };

        caseApi.getExact(params).then((res)=>{
          
          this.slist = this.slist.concat(...res.records || []);
          this.scanMore = true;
          if(res.totalPage == this.spage.current || res.totalPage == 0){
              this.sfinished = true;
          }
          if(res.records.length == 0){
            this.sfinished = true;
          }
          this.sloading = false;
          this.spage.current++;
        })
      },
      submitSearch(obj){
        this.queryCategoryId = obj.queryCategoryId;
        this.queryBrandIdId = obj.queryBrandIdId;
        this.querySymptomName = obj.querySymptomName;
        this.tlist = [];
        this.tpage.current = 1;
        this.tfinished = false;
        this.getExact();
      },
      categoryTab(id){
        if(id == 3){
          zhugeObj.track({
            title : '全部案例',
            content : {
              '包包' : '包包',
            }
          })
        }else if(id == 4){
          zhugeObj.track({
            title : '全部案例',
            content : {
              '鞋靴' : '鞋靴',
            }
          })
        }else if(id == 5){
          zhugeObj.track({
            title : '全部案例',
            content : {
              '衣裤' : '衣裤',
            }
          })
        }else{
          zhugeObj.track({
            title : '全部案例',
            content : {
              '配饰' : '配饰',
            }
          })
        }
      
        if(id == this.queryCategoryId){
          this.queryCategoryId = ''
        }else{
          this.queryCategoryId = id;
        }
        this.queryBrandIdId = '';
        this.querySymptomName = '';
        this.tlist = [];
        this.tpage.current = 1;
        this.tfinished = false;
        this.getExact();
      },
      getExact(){
        if(!this.tcanMore){
          return;
        }
        this.tcanMore = false;
        this.tloading = true;

        let params = {
          brandId : this.queryBrandIdId,
          symptomName : this.querySymptomName,
          current : this.tpage.current,
          size : this.tpage.size
        };

        //6以上是2级品类
        if(this.queryCategoryId){
          if(this.queryCategoryId > 6){
            params.categoryId = this.queryCategoryId
          }else{
            params.firstLevelCategoryId = this.queryCategoryId
          }
        }
        zhugeObj.track({
          title : '全部案例',
          content : {
            '筛选' : '筛选',
            '品牌ID' : this.queryBrandIdId,
            '症状' : this.querySymptomName,
            '品类' : params.categoryId || params.firstLevelCategoryId 
          }
        })

        caseApi.getExact(params).then((res)=>{
          
          this.tlist = this.tlist.concat(...res.records || []);
          this.tcanMore = true;
          if(res.totalPage == this.tpage.current || res.totalPage == 0){
              this.tfinished = true;
          }
          if(res.records.length == 0){
            this.tfinished = true;
          }
          this.tloading = false;
          this.tpage.current++;
        })
      },
      toCaseDetail (id,name) {
        zhugeObj.track({
          title : '精选案例',
          content : {
            '案例名称':name,
          }
        })
        this.$router.push({ name: 'caseDetail' ,query:{id:id}});
      }
    }
  }
</script>

<style lang="scss" scoped>

.caseIndex{
  padding: 0 0 100px;
  .search-wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    position:fixed;
    left: 0;
    top:0;
    z-index: 20;
    border-radius:0 0 35px 35px; 
    /*<!--background: $white-color;-->*/
  }
  .mainTop {
    height: 978px;margin-bottom: 30px;
    .parallax {
      background: #ccc url('/images/case/caseIndex_01.jpg') 0 0 no-repeat;
      background-size: 100%;
      width: 100%;
      height:  978px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  /*导航*/
  nav{
    padding-bottom: 24px;
    div{
      display: inline-block;
      width: 156px;
      height: 66px;
      line-height: 50px;
      /*transition: .3s;*/
    }
    .active{
      font-size: 36px;
      color: $primary-color;
      background: url('/images/case/case_path.png') no-repeat center bottom;
      background-size: 52px;
    }
  }
  .contentWrap{
    .titleWrap{
      padding: 30px;
      h2{
        line-height: 56px;margin-bottom: 8px;
      }
      h4{
        line-height: 40px;
      }
    }
    .caseList{
      padding: 0 30px;
      li{
        margin-bottom: 50px;
        >div{
          height: 92px;
          display: flex;
          justify-content: space-between;
          .left{
            width: 330px;
            h3{ 
              line-height: 44px;
              margin-bottom: 8px;
            }
            h4{
              line-height: 40px;
            }
          }
          .right{
            width: 308px;
            height: 88px;
            line-height: 88px;
            padding:0px 30px;
            border: 1px $primary-color solid;
            text-align: center;
            border-radius:45px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
      }
      img{
        border-radius: $base-radius;
        width: 100%;
        height: 440px;margin-bottom: 20px;
      }
    }
    .recommendList,.allList{
      background: #f6f6f6;
      li{
        margin-bottom: 20px;
      }
    }
    .navBar{
      padding: 30px 30px 20px;
      display: flex;
      justify-content: space-between;
      ul{
        width: 540px;
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        li{
          width:120px;
          height:50px;
          line-height: 48px;
          border-radius:$base-radius;
          border:2px solid $brand-color;
          color: $brand-color;
          box-sizing: border-box;
        }
        .active{
          background: $brand-color;
          color: $white-color;
        }
      }
      .filterBtn{
        width: 114px;
        height: 72px;
        line-height: 72px;
        position: relative;
        >div{
          position: absolute;
          left: 0;
          top:0;
          width:100%;
          height:100%;
          background: $white-color url('/images/case/filter_icon.png') no-repeat 20px 24px;
          background-size: 28px;
          z-index: 10;
        }
        &:after{
          content: "";
          position: absolute;
          left: 10px;
          top:8px;
          width:4px;
          height:56px;
          box-shadow:-2px 0px 20px 0px rgba(0,0,0,0.45);
        }
        /*<!--box-shadow:-2px 0px 20px 0px rgba(0,0,0,0.45);-->*/
      }
    }
  }
}
</style>
